module.exports = __webpack_public_path__ + "img/sixpackcarrier85.0e8c3ffd.jpg";